/*
 * 结算设置
 *
 * @Author: fan.li@zuolin.com
 * @Date: 2019-07-30 19:45:01
 * @Last Modified by: fan.li@zuolin.com
 * @Last Modified time: 2019-08-02 12:03:09
 */

const api = {
	shopDetail: '/shop/detail',
	businessInfo: '/payment/getBusinessInfo',
	registerUrl: '/payment/getPayRegisterURL',
	getToken: '/payment/getPayToken'
};

const routes = {
	'/settlement-manage': '账户信息'
};

export {
	api,
	routes,
};
